export async function postInRoom({ baseUrl, bedImage, milieu, fetchImpl }) {
  const doFetch = fetchImpl || fetch;
  const res = await doFetch(`${baseUrl}in-room`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ bedImage, milieu }),
  });
  let data = {};
  try {
    data = (await res.json()) || {};
  } catch (e) {
    /* non-JSON error body */
  }
  if (!res.ok) {
    throw new Error(data.errorKey || 'inRoom.error.generic');
  }
  return data;
}
